import { Injectable } from "@angular/core";
import { Http, Headers, Response } from "@angular/http";
import { Observable } from 'rxjs';
import 'rxjs/Rx';


@Injectable()
export class AuthService {

    private signupUrl : string = "/signup";
    private signinUrl : string = "/signin";


    constructor(private http:Http) {
    }

    signup(username:string, email:string, password:string){
        return this.http.post(this.signupUrl,
          {name:username, email:email, password:password},
          {headers: new Headers({'X-Requested-With':'XMLHttpRequest'})}
        )
    }

    signin(email:string, password:string){
        return this.http.post(this.signinUrl,
          {email: email, password: password},
          {headers: new Headers({'Content-type':'application/json'})}
        ).map(
          (response:Response) => {
              let user = response.json();

              if (user && user.token) {
                  localStorage.setItem('currentUser', JSON.stringify(user) );
              }
          }
        )
    }

    getToken() {
        if (localStorage.getItem('currentUser')) {
            var user = JSON.parse(localStorage.getItem('currentUser'));
            return user.token;
        }
        return false;
    }
    getUser() {
      if (localStorage.getItem('currentUser')) {
          var user = JSON.parse(localStorage.getItem('currentUser'));
          return user.user;
      }
      return false;
    }

    logout() {
        return this.http.get('/logout',
        {headers: new Headers({'Content-type':'application/json'})})
        .subscribe((response:Response) => {
              localStorage.removeItem('currentUser');
          }
        );
    }
}



// WEBPACK FOOTER //
// /Users/alexandre/Documents/web/riberfuso/resources/ng/src/app/auth.service.ts